import React from 'react'

import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Text from '@/ui/Text'

const TextFormatted = ({
  label,
  labelId,
  values,
  variant,
  ellipsis,
  ...props
}) => {
  return (
    <Text variant={variant} ellipsis={ellipsis} {...props}>
      {!!labelId && <FormattedMessage id={labelId} values={values} />}
      {label}
    </Text>
  )
}

TextFormatted.propTypes = {
  label: PropTypes.any,
  labelId: PropTypes.string,
  values: PropTypes.object,
  ellipsis: PropTypes.bool,
  variant: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  colorVariant: PropTypes.oneOf(['primary', 'secondary']),
}

export default TextFormatted
